import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  excelDownloadAction,
  loadingMasterAction,
} from "../../redux/actions/master.action";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DownloadExcelModal = ({
  show,
  handleClose,
  commonData,
  data,
  componentOption,
  selectedDetailOption,
  setSelectedDetailOption,
  selectedKeys,
  setSelectedKeys,
  dataKeys,
  filterList,
  searchValue,
  setSearchValue,
  searchData,
  showCheckboxes,
  setShowCheckboxes,
}) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth); // Adjust this if you have user info elsewhere

  const { pagination, ExcelFile } = useSelector((state) => state.master);

  // Make sure commonData is available

  const allList = commonData?.length > 0 ? Object.keys(commonData[0]) : [];

  const allKeys = allList.filter((list) => list !== "_id");

  let frontendFilter = {
    [dataKeys.keys === undefined ? filterList : dataKeys.keys]:
      dataKeys.value === undefined ? "" : dataKeys.value,
  };

  const handleCheckboxChange = (key) => {
    setSelectedKeys((prevSelectedKeys) => {
      if (!Array.isArray(prevSelectedKeys)) return [];

      const isSelected = prevSelectedKeys.includes(key);
      const updated = isSelected
        ? prevSelectedKeys.filter((item) => item !== key)
        : [...prevSelectedKeys, key];

      // Only update dropdown if key is 'Componentdetails'
      if (key === "Componentdetails") {
        setSelectedDetailOption(
          isSelected
            ? { value: "NO", label: "without details" }
            : { value: "YES", label: "with details" }
        );
      }

      return updated;
    });
  };

  const handleDownloadAll = () => {
    dispatch(loadingMasterAction(true));

    if (selectedDetailOption && selectedDetailOption.value === "NO") {
      const updatedKeys = allKeys.filter((key) => key !== "Componentdetails");

      dispatch(
        excelDownloadAction(
          data,
          updatedKeys,
          selectedOption,
          frontendFilter,
          searchData.findsubareaId
        )
      );

      setSelectedKeys([]);
    } else {
      dispatch(
        excelDownloadAction(
          data,
          allKeys,
          selectedOption,
          frontendFilter,
          searchData.findsubareaId
        )
      );
      // handleClose();
      setSelectedKeys(["Componentdetails"]);
    }
  };

  const handleDownloadSelected = () => {
    dispatch(loadingMasterAction(true));
    dispatch(
      excelDownloadAction(
        data,
        selectedKeys,
        selectedOption,
        frontendFilter,
        searchData.findsubareaId
      )
    );

    setSelectedKeys([]);
    // setSelectedOption({ label: "1-4000", value: "0" }); // Default to "0-3999" if no option is selected
  };

  const onHideModal = () => {
    setSelectedKeys([]); // Reset the selected keys when modal is closed
    setSearchValue("");
    handleClose();
    setSelectedDetailOption({ value: "NO", label: "without details" });

    // setSelectedOption({ label: "1-4000", value: "0" });
  };

  const handleComponentDetailOption = (selectedOption) => {
    setSelectedDetailOption(selectedOption);

    setSelectedKeys((prevKeys) => {
      if (!Array.isArray(prevKeys)) return [];

      const hasComponent = prevKeys.includes("Componentdetails");

      if (selectedOption?.value === "YES") {
        return hasComponent ? prevKeys : [...prevKeys, "Componentdetails"];
      } else {
        return prevKeys.filter((key) => key !== "Componentdetails");
      }
    });
  };

  const generatePaginationOptions = (totalCount) => {
    const maxPerPage = 4000;
    const page = Math.ceil(totalCount / maxPerPage);
    let paginationArray = [];
    for (let index = 0; index < page; index++) {
      const maxPerpage = maxPerPage * (index + 1);
      const value = maxPerPage * index;
      const lastPage = maxPerpage >= totalCount ? totalCount : maxPerpage;
      const key = `${value + 1}-${lastPage}`;
      paginationArray.push({ label: key, value });
    }

    return paginationArray;
  };

  const paginationOptions = generatePaginationOptions(pagination.totalCount);

  const [selectedOption, setSelectedOption] = useState(
    paginationOptions[0]?.value
  );

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption ? selectedOption.value : 0); // Default to 0 if no option is selected
  };

  const handleSearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const isAdmin = user?.role === "admin"; // Or however you identify admin

  const filterKeys = allKeys.filter((key) => {
    const keyLower = key.toLowerCase();

    const passesSearch =
      searchValue.length >= 3
        ? key && keyLower.includes(searchValue.toLowerCase())
        : true;

    const isSuid = keyLower.endsWith("suid");

    return passesSearch && (isAdmin || !isSuid);
  });

  // const checkAllFilled = () => {
  //   const allVisibleKeys = filterKeys;

  //   // Always include Componentdetails if it's available and selectedDetailOption is YES
  //   if (
  //     allVisibleKeys.includes("Componentdetails") &&
  //     selectedDetailOption?.value === "YES"
  //   ) {
  //     setSelectedKeys([...allVisibleKeys, "Componentdetails"]);
  //   } else {
  //     setSelectedKeys(allVisibleKeys);
  //   }
  // };

  return (
    <Modal
      show={show}
      onHide={onHideModal}
      size="xl"
      modaltransition={{ timeout: 300 }}
    >
      <Modal.Header>
        <Modal.Title>Export and Download</Modal.Title>
        <div>
          <Button
            className="mr-2"
            variant="primary"
            onClick={handleDownloadAll}
          >
            Prepare All Fields
          </Button>

          <Button
            className="mr-2"
            variant="secondary"
            onClick={() => setShowCheckboxes(!showCheckboxes)}
          >
            Select Fields
          </Button>
          <button
            onClick={handleClose}
            className="btn btn-sm btn-outline-secondary"
          >
            <FontAwesomeIcon
              type="button"
              className="text-black"
              icon={faClose}
              size="lg"
            />
          </button>
        </div>
      </Modal.Header>
      <Modal.Body className="mx-3">
        <div className="mb-3 row align-items-center">
          <label htmlFor="selectField" className="mr-2">
            Component
          </label>

          <Select
            className="w-25"
            value={selectedDetailOption}
            isDisabled={!allKeys.includes("Componentdetails")}
            onChange={(selectedOption) =>
              handleComponentDetailOption(selectedOption)
            }
            options={componentOption}
            placeholder="Select an option"
            menuPortalTarget={document.body} // 💥 this makes it render outside modal
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />

          <label htmlFor="selectSkip" className="mr-2 ml-2">
            Select Skip:
          </label>

          <Select
            className="w-25"
            value={paginationOptions.find(
              (option) => option.value === selectedOption
            )}
            onChange={handleChange}
            options={paginationOptions}
            getOptionLabel={(e) => e.label}
            getOptionValue={(e) => e.value}
            placeholder="Select an option"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
        </div>

        {showCheckboxes && (
          <>
            <div
              className="mb-3 row justify-content-start mt-3"
              style={{ gap: "10px" }}
            >
              <label for="exampleFormControlInput1" className="form-label">
                Search Fields:
              </label>
              <input
                type="text"
                className="form-control w-25"
                id="exampleFormControlInput1"
                placeholder="Search ..."
                onChange={(e) => {
                  handleSearchValue(e);
                }}
                value={searchValue}
              />
            </div>
            <div className="mb-3 d-flex align-items-center">
              <input
                type="checkbox"
                checked={
                  filterKeys.length > 0 &&
                  filterKeys.every((key) => selectedKeys.includes(key))
                }
                ref={(input) => {
                  if (input) {
                    const isIndeterminate =
                      selectedKeys.length > 0 &&
                      selectedKeys.length < filterKeys.length;
                    input.indeterminate = isIndeterminate;
                  }
                }}
                onChange={(e) => {
                  const shouldCheck = e.target.checked;
                  if (shouldCheck) {
                    setSelectedKeys(filterKeys);
                    if (filterKeys.includes("Componentdetails")) {
                      setSelectedDetailOption({
                        value: "YES",
                        label: "with details",
                      });
                    }
                  } else {
                    setSelectedKeys([]);
                    setSelectedDetailOption({
                      value: "NO",
                      label: "without details",
                    });
                  }
                }}
              />
              <label className="ml-2">Select All</label>
            </div>

            <div style={{ maxHeight: "450px", overflowY: "auto" }}>
              {filterKeys?.map((key) => (
                <div className="d-flex align-items-center mb-2" key={key}>
                  <input
                    type="checkbox"
                    checked={selectedKeys.includes(key)}
                    onChange={() => handleCheckboxChange(key)}
                  />
                  <label className="ml-2">{key}</label>
                </div>
              ))}
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div>
          {ExcelFile && ExcelFile !== "" && (
            <div className="d-flex justify-content-center align-items-center gap-1">
              <span style={{ fontWeight: "600", paddingRight: "5px" }}>
                Ready for Download:
              </span>
              <a href={ExcelFile} download>
                <button className="btn btn-sm btn-outline-success">
                  Download
                </button>
              </a>
            </div>
          )}
        </div>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        {showCheckboxes && (
          <Button variant="primary" onClick={handleDownloadSelected}>
            Download Selected Fields
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(DownloadExcelModal);
